import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  noData: {
    padding: 32,
  },
}));

export default useStyles;
